import { render, staticRenderFns } from "./ListOrder.vue?vue&type=template&id=b683cfde&scoped=true&"
import script from "./ListOrder.vue?vue&type=script&lang=ts&"
export * from "./ListOrder.vue?vue&type=script&lang=ts&"
import style0 from "./ListOrder.vue?vue&type=style&index=0&id=b683cfde&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../boss_taobao/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b683cfde",
  null
  
)

export default component.exports